var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "camera",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "camera-1",
    d: "M20.8,0 L23.7282078,3.22277668 L28.8,3.22277668 L28.9640649,3.22698924 C30.6489838,3.31369342 32,4.7277874 32,6.44472167 L32,6.44472167 L32,25.7772233 L31.9958166,25.9424009 C31.9097127,27.6387797 30.5054026,29 28.8,29 L28.8,29 L3.2,29 L3.03593512,28.9957851 C1.35101623,28.9090321 0,27.4941576 0,25.7772233 L0,25.7772233 L0,6.44472167 L0.00418339083,6.27954653 C0.0902873377,4.58321646 1.4945974,3.22277668 3.2,3.22277668 L3.2,3.22277668 L8.27179221,3.22277668 L11.2,0 L20.8,0 Z M16,8.05569417 L15.7723423,8.05889817 C11.4614792,8.18038056 8,11.7410451 8,16.1113883 C8,20.5575726 11.584,24.1670825 16,24.1670825 L16,24.1670825 L16.2276992,24.1638778 C20.5393236,24.0423679 24,20.4809143 24,16.1113883 L24,16.1113883 L23.9968186,15.8821321 C23.8761946,11.5410079 20.3406789,8.05569417 16,8.05569417 L16,8.05569417 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera-2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "camera-3",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "camera-4",
    xlinkHref: "#camera-1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "camera-5",
    fill: "#000",
    points: "-3 32 35 32 35 -3 -3 -3",
    mask: "url(#camera-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.acb8f3f04f3cc872dbae8a9c1ba2d948.svg";
export { ForwardRef as ReactComponent };